// store/iconsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import localIcons from "@/assets/icons/back_icons.json";
import { GQL_ICONS } from "@/Config/Graphql/Screens/icons"; // certifique-se de que está importado

export const fetchIconsFromDB = createAsyncThunk(
  "icons/fetch",
  async (fetchApollo, thunkAPI) => {
   
    try {
      const data = await fetchApollo(GQL_ICONS);      
      const getData = data?.icons_gql?.data || [];   
      

      if (!getData || getData === 0) {
        return thunkAPI.rejectWithValue("Lista de ícones vazia.");
      }
      
      const currentUpdateMap = thunkAPI.getState().icons.lastUpdatedMap || {};
      const currentIcons = thunkAPI.getState().icons.data;

      let changed = false;
      const newIcons = { ...currentIcons };
      const newUpdateMap = { ...currentUpdateMap };

      getData.forEach(element => {
        const newUpdatedAt = element.updated_at;
        const iconId = element.id.toString();

        if (newUpdatedAt !== currentUpdateMap[iconId]) {
          changed = true;
          newIcons[iconId] = {
            id: parseInt(iconId),
            icon_svgs: element.icon_svgs,
            icon_paths: element.icon_paths,
            icon_ellipses: element.icon_ellipses,
            icon_circle: element.icon_circle,
            icon_polygon: element.icon_polygon,
          };
          newUpdateMap[iconId] = newUpdatedAt;
        }
      });

      if (!changed) {
       
        return thunkAPI.rejectWithValue("Sem mudanças");
      }

      return { icons: newIcons, updateMap: newUpdateMap };

    } catch (error) {
      return thunkAPI.rejectWithValue("Erro ao buscar ícones.");
    }
  }
);

const iconsSlice = createSlice({
  name: "icons",
  initialState: {
    data: localIcons,
    lastUpdatedMap: {}, // novo estado
    loading: false,
    error: null,
  },
  reducers: {
    setIconsFromLocal: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchIconsFromDB.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIconsFromDB.fulfilled, (state, action) => {
        state.data = action.payload.icons;
        state.lastUpdatedMap = action.payload.updateMap;
        state.loading = false;
      })
      .addCase(fetchIconsFromDB.rejected, (state, action) => {
        state.loading = false;
        if (action.payload !== "Sem mudanças") {
          state.error = action.payload || action.error.message;
        }
      });
  },
});

export const { setIconsFromLocal } = iconsSlice.actions;
export default iconsSlice.reducer;
